import { useHidePrices } from "@/contexts/HidePricesContext";
import { cn } from "@/lib/utils";

interface ProductPriceProps {
  price: number;
  priceFormatted?: string;
  className?: string;
}

export function ProductPrice({ price, priceFormatted, className }: ProductPriceProps) {
  const { hidePrices } = useHidePrices();

  if (hidePrices) return null;

  return <span className={cn(className)}>{priceFormatted || `$${price.toFixed(2)}`}</span>;
}
